/* jshint esversion: 6 */

import $ from '@/components/js/jquery-vendor';
import {getResponsiveBreakpoint, getViewPort} from '@/components/js/app.js';

var resBreakpointMd = getResponsiveBreakpoint('md');

function handleHeaderMenu() {
            
    $('.page-header .navbar-nav > .dropdown-fw, .page-header .navbar-nav > .more-dropdown, .page-header .navbar-nav > .dropdown > .dropdown-menu  > .dropdown').click(function(e) {
        
        if (getViewPort().width > resBreakpointMd) {
            if ($(this).hasClass('more-dropdown') || $(this).hasClass('more-dropdown-sub')) {
                return;
            } else {
                e.stopPropagation();
            }
        } else {
            e.stopPropagation();
        }
        
        var links = $(this).parent().find('> .dropdown');

        if (getViewPort().width < resBreakpointMd) {
            if ($(this).hasClass('open')) {
                links.removeClass('open');
            } else {
                links.removeClass('open');
                $(this).addClass('open');
                // scrollTo($(this));
            }
        } else {
            if ($(this).hasClass('more-dropdown'))  {
                return;
            }
            links.removeClass('open');
            $(this).addClass('open');
            // scrollTo($(this));
        }
    });

    $('.page-header .navbar-nav .more-dropdown-sub .dropdown-menu, .page-header .navbar-nav .dropdown-sub .dropdown-menu').click(function(){

    });
}

function activeMenu(menu) {
    $("li.active.open.selected").removeClass("active").removeClass("open").removeClass("selected");
      $("li.active").removeClass("active");
      if(menu.length==2) {
          $("[href*='"+menu+"']").parent().addClass("active open selected");
          $("[href*='"+menu+"']").next().children().addClass("active");
      }
      else if(menu.length==4||menu.length==5) {
          $("[href*='"+menu+"']").parent().parent().parent().addClass("active open selected");
          $("[href*='"+menu+"']").next().parent().addClass("active");
      }
      else if(menu.length==6) {
          $("[href*='"+menu+"']").parent().parent().parent().parent().parent().addClass("active open selected");
          $("[href*='"+menu+"']").parent().parent().parent().addClass("active");
      }
}

export {
    handleHeaderMenu, activeMenu
};